import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'

import { useActiveAccount } from '../utils/activeAccountContext'
import { setBrowserErrorOrgSlug } from '../utils/browserErrorReporter'
import type { CurrentUserContextValue } from '../utils/currentUserContext'
import { useCurrentUser } from '../utils/currentUserContext'

const DATADOG_USER_TYPE_BY_ROLE = {
  AGENT: undefined,
  AUTOMATION: undefined,
  BILLER: 'bpo',
  BILLING_MANAGER: 'internal',
  BILLING_SUPERVISOR: 'bpo',
  JOYFUL_ADMIN: 'internal',
  PRACTICE_ADMIN: 'practice',
  PRACTICE_MEMBER: 'practice',
  PRACTICE_VIEWER: 'practice',
  RCM_SPECIALIST: 'internal',
  SERVICES_PRACTICE_ADMIN: 'practice',
} satisfies Record<
  CurrentUserContextValue['role'],
  'practice' | 'bpo' | 'internal' | undefined
>

export function DatadogRumUserIdentity() {
  const { feature_flags, id, role } = useCurrentUser()

  useEffect(() => {
    datadogRum.setUser({
      feature_flags: Array.from(feature_flags),
      id,
      role,
      user_type: DATADOG_USER_TYPE_BY_ROLE[role],
    })

    return () => {
      datadogRum.clearUser()
    }
  }, [feature_flags, id, role])

  return null
}

export function DatadogRumAccountIdentity() {
  const activeAccount = useActiveAccount()
  setBrowserErrorOrgSlug(activeAccount?.slug ?? null)

  useEffect(() => {
    if (activeAccount) {
      datadogRum.setAccount({
        id: activeAccount.id,
        name: activeAccount.name ?? activeAccount.slug,
        slug: activeAccount.slug,
      })
    } else {
      datadogRum.clearAccount()
    }

    return () => {
      datadogRum.clearAccount()
    }
  }, [activeAccount])

  return null
}
